import { Modal, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { ManageSubscriptionsInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getCancelSubscriptionApiHandler } from '../utils/get-cancel-subscription-api-handler';
interface CancelSubscriptionModalProps {
  opened: boolean;
  onClose: () => void;
  subscription: ManageSubscriptionsInterface;
  onUnsubscribe: (subscriptionItemId: number) => Promise<void>;
}
function CancelSubscriptionModal({
  opened,
  onClose,
  subscription,
  onUnsubscribe
}: CancelSubscriptionModalProps) {
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const cancelSubscriptionApiHandler = getCancelSubscriptionApiHandler(subscription.paymentProcessor, subscription.id, subscription.subscriptionItems?.[0]?.id || 0);
  const handleConfirm = async () => {
    try {
      setIsFetching(true);
      await cancelSubscriptionApiHandler();
      await onUnsubscribe(subscription.subscriptionItems?.[0]?.id || 0);
      setIsFetching(false);
      onClose();
      toast.success(t('dashboard.subscriptions.unsubscribed'));
    } catch (e) {
      setIsFetching(false);
      if (e instanceof BadRequest) {
        if (e.errors.common) {
          setError(e.errors.common.join(''));
        }
      } else if (e instanceof InternalError) {
        setError(t('core.error.internal_error_message'));
      } else {
        toast.error(t('global.error'));
      }
    }
  };
  return <>
      <Modal opened={opened} onClose={onClose} title={t('confirmation_modal.default_title')} isFetching={isFetching}>
        <form className="flex flex-col gap-6 lg:gap-10">
          <div className="flex justify-center">
            <p>{t('dashboard.settings.manage_subscriptions.unsubscribe_confirmation')}</p>
          </div>
          <div className="flex justify-center gap-4">
            <SecondaryButton width="large" onClick={(e_0: React.MouseEvent<HTMLButtonElement>) => {
            e_0.preventDefault();
            onClose();
          }} disabled={isFetching}>
              {t('confirmation_modal.cancel')}
            </SecondaryButton>
            <PrimaryButton isFetching={isFetching} width="large" onClick={async (e_1: React.MouseEvent<HTMLButtonElement>) => {
            e_1.preventDefault();
            await handleConfirm();
          }} type="submit">
              {t('confirmation_modal.confirm')}
            </PrimaryButton>
          </div>
          <FieldErrorAndDescription error={error} errorClassName={'text-center'} />
        </form>
      </Modal>
    </>;
}
export default CancelSubscriptionModal;